export default "__VITE_ASSET__111dbf26__"